
import { Helmet } from "react-helmet";
import { Mail } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import NavigationButtons from '@/components/NavigationButtons';

const Contact = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "DeepSeek AI",
    "url": "https://deepseek.ai/contact",
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "info@deepseek.ai",
      "contactType": "customer service",
      "areaServed": "Worldwide",
      "availableLanguage": ["English"]
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact DeepSeek AI | Get in Touch with Our AI Experts</title>
        <meta name="description" content="Contact DeepSeek AI for advanced artificial intelligence solutions and expert consultation. Our team is ready to help transform your business with cutting-edge AI technology." />
        <meta name="keywords" content="contact DeepSeek AI, AI consultation, artificial intelligence support, AI solutions contact, DeepSeek support" />
        <link rel="canonical" href="https://deepseek.ai/contact" />
        
        <meta property="og:title" content="Contact DeepSeek AI | Expert AI Consultation" />
        <meta property="og:description" content="Get in touch with DeepSeek AI's experts for advanced artificial intelligence solutions and consultation." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://deepseek.ai/contact" />
        
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>

      <div className="min-h-screen pt-20 bg-gradient-to-br from-blue-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Contact Us</h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Have questions about our AI solutions? We're here to help and would love to hear from you.
            </p>
          </div>

          <NavigationButtons />

          <div className="max-w-lg mx-auto">
            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <Mail className="w-12 h-12 text-deepseek-primary mx-auto mb-4" />
                <h2 className="text-xl font-semibold mb-2">Email Us</h2>
                <a 
                  href="mailto:info@deepseek.ai" 
                  className="text-gray-600 hover:text-deepseek-primary transition-colors"
                >
                  info@deepseek.ai
                </a>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
